export const alibabaFlashVoices: string[] = [
  'Cherry',
  'Ethan',
  'Nofish',
  'Jennifer',
  'Ryan',
  'Katerina',
  'Elias',
  'Jada',
  'Dylan',
  'Sunny',
  'li',
  'Marcus',
  'Roy',
  'Peter',
  'Rocky',
  'Kiki',
  'Eric',
];

export const alibabaVoices: string[] = [
  'Vivian',
  'Serena',
  'Ono_Anna',
  'Sohee',
  'Uncle_Fu',
  'Dylan',
  'Eric',
  'Ryan',
  'Aiden',
];